import { Breadcrumbs, Typography } from "@mui/material";
import React from "react";
import { Link } from "react-router-dom";

interface BradCrumbsProps {
  link: string;
  field: string;
  extra: InsideEl[];
}

interface InsideEl {
  text: string;
}

const BreadCrumbs = ({ link, field, extra }: BradCrumbsProps) => {
  return (
    <Breadcrumbs
      aria-label="breadcrumb"
      sx={{
        marginBottom: "10px",
      }}
    >
      <Link to={link}>
        <Typography color="text.primary" fontWeight={600}>
          {field}
        </Typography>
      </Link>
      {extra.map((el, index) => (
        <Typography key={index} color="text.primary">
          {el.text}
        </Typography>
      ))}
    </Breadcrumbs>
  );
};

export default BreadCrumbs;
